import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { X } from "lucide-react";
import { StartupRole } from "./types";
interface RoleManagerProps {
  roles: StartupRole[];
  onRolesChange: (roles: StartupRole[]) => void;
}
export const RoleManager = ({
  roles,
  onRolesChange
}: RoleManagerProps) => {
  const [currentRole, setCurrentRole] = useState<StartupRole>({
    title: "",
    description: ""
  });
  const addRole = () => {
    if (!currentRole.title.trim()) return;
    onRolesChange([...roles, currentRole]);
    setCurrentRole({
      title: "",
      description: ""
    });
  };
  const removeRole = (index: number) => {
    const newRoles = roles.filter((_, i) => i !== index);
    onRolesChange(newRoles);
  };
  return <div className="space-y-4">
      <div className="space-y-4">
        <Label>Team Roles</Label>
        {roles.map((role, index) => <div key={index} className="flex items-start gap-2 p-3 rounded-md bg-flux-black/30 border border-flux-cyan/20">
            <div className="flex-1">
              <p className="font-medium text-flux-cyan">{role.title}</p>
              {role.description && <p className="text-sm text-gray-400 mt-1">{role.description}</p>}
            </div>
            <Button variant="ghost" size="icon" onClick={() => removeRole(index)} className="text-gray-400 hover:text-red-400">
              <X className="h-4 w-4" />
            </Button>
          </div>)}
      </div>

      <div className="space-y-4 p-4 rounded-md bg-flux-black/30 border border-flux-cyan/20">
        <div className="space-y-2">
          <Label htmlFor="roleTitle">Role Title</Label>
          <Input id="roleTitle" value={currentRole.title} onChange={e => setCurrentRole({
          ...currentRole,
          title: e.target.value
        })} placeholder="e.g., Frontend Developer" className="bg-flux-black/50" />
        </div>

        <div className="space-y-2">
          <Label htmlFor="roleDescription">Description (Optional)</Label>
          <Textarea id="roleDescription" value={currentRole.description} onChange={e => setCurrentRole({
          ...currentRole,
          description: e.target.value
        })} placeholder="Describe the role and requirements..." className="bg-flux-black/50" />
        </div>

        <Button type="button" onClick={addRole} disabled={!currentRole.title.trim()} className="w-full bg-flux-cyan hover:bg-flux-cyan/80 text-gray-50 bg-zinc-600 hover:bg-zinc-500">
          Add Role
        </Button>
      </div>
    </div>;
};